import {gql} from "@apollo/client";
import {AccountType} from "graphql/types/AccountType";

export const GET_ACCOUNT_LISTING_FOR_WAREHOUSE = gql`
    query GetAccountListingForWarehouse($warehouseId: Long!) {
        allAccounts: getAccountListingForWarehouse(warehouseId: $warehouseId) {
            id
            name
            countryCode
            phone
            email
            status
            role {
                name
            }
            createdAt
            updatedAt
        }
    }
`;

export interface GetAccountListingForWarehouseResponse {
    allAccounts: AccountType[];
}

